<app-public-page [pageCaption]="">
  <!-- <section class="login-form inschrijven" name="loginform"> -->
    <form [formGroup]="registrationForm">
      <input type="text" placeholder="{{audio.text.login.username}}*" required formControlName="username" (focus)="audio.play('register_voerjenaamin')">
      <input type="password" placeholder="{{audio.text.login.password}}*" required formControlName="password" (focus)="audio.play('register_voerjewachtwoordin')">
      <input type="password" placeholder="{{audio.text.register.passwordConfirm}}*" required formControlName="passwordValidation" (focus)="audio.play('register_voerjewachtwoordin2')">
      <input type="email" placeholder="{{audio.text.register.emailAddress}}*"  required formControlName="email"  (focus)="audio.play('register_voerjeemailadresin')" >

      <div class="button-bar">
        <app-button (click)="login(); audio.playSoundClick();">{{audio.text.global.back}}</app-button>
        <app-button (click)="register(); audio.playSoundClick();">{{audio.text.register.subscribe}}</app-button>
      </div>
      <div class="notes">
        <div class="error subnote errorMessage" ><span>{{errorMessage}}</span></div>
      </div>

      <app-line></app-line>
      <div class="subnote">*{{audio.text.register.requiredFields}}</div>

    </form>

  <!-- </section> -->
</app-public-page>
